import * as Yup from 'yup';
import { bankAccountSchema } from '../bankAccountValidations';
import { APPLICANT_TYPES } from '../../constants/claim';
import { getLegalEntityValidator, getPhysicalEntityValidator } from './claimApplicantDetailsValidation';

export const keys = {
  citizenshipKey: 'paymentReceiverCitizenship',
  birthdayKey: 'paymentReceiverBirthday',
  firstNameKey: 'paymentReceiverFirstName',
  lastNameKey: 'paymentReceiverLastName',
  passportKey: 'paymentReceiverPassport',
  passportGivenDateKey: 'paymentReceiverPassportGivenDate',
  passportValidUntilKey: 'paymentReceiverPassportValidUntil',
  passportFromKey: 'paymentReceiverPassportFrom',
  socCardKey: 'paymentReceiverSocCard',
  genderKey: 'paymentReceiverGender',
};

export const compensationSchema = Yup.object()
  .shape({
    transferBank: Yup.object()
      .nullable()
      .required('validationErrors.isRequired'),
    transferAccount: Yup.string().when('transferType', (transferType, schema) => (transferType === 'account' ? schema.concat(bankAccountSchema) : schema)),
  })
  .concat(
    Yup.object().shape(
      getPhysicalEntityValidator({
        ...keys,
        when: 'paymentReceiverType',
        is: (applicantIs) => applicantIs === APPLICANT_TYPES[1].value,
      }),
    ),
  )
  .concat(
    Yup.object().shape(
      getLegalEntityValidator({
        hvhh: 'paymentReceiverHvhh',
        organizationName: 'paymentReceiverName',
        email: 'paymentReceiverEmail',
        emailConfirmation: 'paymentReceiverEmailConfirmation',
        phone: 'paymentReceiverPhone',
        when: 'paymentReceiverType',
        is: (paymentReceiverType) => paymentReceiverType === 'otherLegal',
      }),
    ),
  );

export default compensationSchema;
